import { OpeningHour } from '../types';

export const WEEK_DAYS = [
  { dia: 1, curto: 'Seg', nome: 'Segunda' },
  { dia: 2, curto: 'Ter', nome: 'Terça' },
  { dia: 3, curto: 'Qua', nome: 'Quarta' },
  { dia: 4, curto: 'Qui', nome: 'Quinta' },
  { dia: 5, curto: 'Sex', nome: 'Sexta' },
  { dia: 6, curto: 'Sáb', nome: 'Sábado' },
  { dia: 7, curto: 'Dom', nome: 'Domingo' },
];

/**
 * Resumo do horário para listagens, agrupando dias seguidos com o mesmo horário.
 * Ex.: "Seg–Sex 06:00–22:00 · Sáb 07:00–20:00"
 */
export const formatOpeningHours = (aberto24h?: boolean, horarios?: OpeningHour[]): string => {
  if (aberto24h) return 'Aberto 24 horas';
  if (!horarios || horarios.length === 0) return '';

  const porDia = WEEK_DAYS.map(({ dia }) =>
    horarios
      .filter((h) => h.diaSemana === dia)
      .sort((a, b) => a.abre.localeCompare(b.abre))
      .map((h) => (h.abre === h.fecha ? '24h' : `${h.abre}–${h.fecha}`))
      .join(', ')
  );

  const grupos: string[] = [];
  let inicio = 0;
  for (let i = 1; i <= 7; i++) {
    if (i < 7 && porDia[i] === porDia[inicio]) continue;
    if (porDia[inicio]) {
      const dias =
        i - 1 === inicio ? WEEK_DAYS[inicio].curto : `${WEEK_DAYS[inicio].curto}–${WEEK_DAYS[i - 1].curto}`;
      grupos.push(`${dias} ${porDia[inicio]}`);
    }
    inicio = i;
  }
  return grupos.join(' · ');
};
